import React, { useState } from 'react';
import { getCSRFToken } from '../utils/auth';
const apiUrl = process.env.REACT_APP_API_URL;

const TranscriptionTool = () => {
  const [selectedFile, setSelectedFile] = useState(null);
  const [transcription, setTranscription] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleFileChange = (event) => {
    setSelectedFile(event.target.files[0]);
  };

  const handleUpload = async () => {
    if (!selectedFile) {
      alert('Please select an audio file.');
      return;
    }

    setIsLoading(true);
    setError(null);

    const formData = new FormData();
    formData.append('audio', selectedFile);
    //console.log(`csrftoken: ${csrftoken}`);

    try {
      // Replace with your actual API endpoint
      const response = await fetch(`${apiUrl}/ai/api/transcribe/`, {
        method: 'POST',
        headers: {
            "X-CSRFToken": getCSRFToken(),  // This will still be empty due to domain mismatch
          },        
        body: formData,
        credentials: 'include',
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      setTranscription(data.google.transcription); // Assuming the API returns { transcription: "..." }
    } catch (e) {
      setError(e.message);
      console.error("Transcription error:", e);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div>
      {/* <h3>Transcription Tool</h3> */}
      <input type="file" accept="audio/*" onChange={handleFileChange} />
      <button onClick={handleUpload} disabled={isLoading}>
        {isLoading ? 'Transcribing...' : 'Upload & Transcribe'}
      </button>

      {error && <p style={{ color: 'red' }}>Error: {error}</p>}
      {isLoading && <p>Loading...</p>}
      {transcription && (
        <div>
          <h4>Transcription:</h4>
          <p>{transcription}</p>
        </div>
      )}
    </div>
  );
};

export default TranscriptionTool;